import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import closeicon from '../../images/popups/upload/closeicon.png';
import '../../scss/popups/formsubmission.scss';
import parse from 'html-react-parser';
import editIcon from '../../images/common/edit-blue.png';
import addIcon from '../../images/common/add.png';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import { convertUTCToPST, isURLEncoded, escapeHtml } from '../Reusables/Function';

var formSubmitDate = "";
var formUpdateDate = "";
function FormSubmission(props) {
    const { formlistdata, toggle, setFormEditted, page } = props;
    const navigate = useNavigate();
    const title = formlistdata.title ? formlistdata.title : '';
    const brand = formlistdata.brandName ? formlistdata.brandName : '';
    const formContentData = formlistdata.formContent ? JSON.parse(formlistdata.formContent) : '';
    const formContent = formContentData;
    const [edit, setEdit] = useState(false);
    const [formDetails, setFormDetails] = useState({});
    const [formContentArray, setFormContentArray] = useState([]);
    const [count, setCount] = useState(0);
    const newFields = [
        'Logo Link', 'Unsubscribe Link', 'Previous Campaign Link', 'Project Code', 'Campaign Id', 'Target Filter'
    ];
    const textareaRefs = useRef([]);
    const altImageTexts = {
        imageFileName: "Alt Text",
        tile2ImageFileName: "Tile2 Alt Text",
        tile3ImageFileName: "Tile3 Alt Text",
        tile4ImageFileName: "Tile4 Alt Text",
        tile5ImageFileName: "Tile5 Alt Text",
        tile6ImageFileName: "Tile6 Alt Text",
        tile7ImageFileName: "Tile7 Alt Text"
    };

    useEffect(() => {
        var fieldCount = -1;
        setEdit(false);
        for (const key in formDetails) {
            delete formDetails[key];
        }


        for (const property in formContent) {
            if(formContent[property].order >= fieldCount) {
                fieldCount = formContent[property].order;
            } 

            // To remove unwanted alt text after businessNameAndAddress key
            if(property === "Alt Text" && formContent[property].order > 40) {
                delete formContent[property];
            }
        }
    
        var formArray = [];
        for(var i = -1; i <= fieldCount; i++) {
            for(const property in formContent) {
                if(i == formContent[property].order && formContent[property].value != null) {
                    var formContentObj = {
                        key: property,
                        value: formContent[property].value,
                        order: formContent[property].order, 
                        type: formContent[property].type
                    }

                    if(property === 'dateSubmitted' || property === 'dateUpdated') {
                        var dateString = formContent[property].value;
                        formContentObj.value = convertUTCToPST(dateString, "updates");

                        if(property === 'dateSubmitted') {
                            formSubmitDate = dateString;
                        } else {
                            formUpdateDate = dateString;
                        }
                    }
        
                    if(property === "businessNameAndAddress") {
                        var address = formContent[property].value
                        if(address.slice(-2) == ', ') {
                            formContentObj.value = address.slice(0, -2);
                        }
                    }
                    formArray.push(formContentObj);

                    if(property in altImageTexts) {
                        const altTextExists = Object.keys(formContent).includes(altImageTexts[property]);
                        if(!altTextExists) {
                            fieldCount += 1;
                            var newFieldObj = {
                                key: altImageTexts[property],
                                value: '',
                                order: formContent[property].order + 1,
                                type: ''
                            }
                            formArray.push(newFieldObj);
                        }
                    }
                }
            }
        }

        // Adding new fields
        if(title.includes('provide-specs') && brand.toLowerCase() == 'hilton') {
            fieldCount += 1;
            newFields.length > 0 && newFields.map(item => {
                const itemFound = formArray.find(existingItem => existingItem.key === item);
                if(!itemFound) {
                    var newFieldObj = {
                        key: item,
                        value: '',
                        order: fieldCount,
                        type: ''
                    }
                    fieldCount += 1;
                    formArray.push(newFieldObj);
                }
            })
        }

        setFormContentArray(formArray);
        setCount(fieldCount);
    }, [toggle])

    const handleEdit = () => {
        setEdit(true);
    }

    const handleSave = () => {
        setEdit(false);

        for (const formContent of formContentArray) {
            if(formContent.key != "") {
                let encodedValue = ""
                if(formContent.key !== 'dateSubmitted' && formContent.key !== "dateUpdated") {
                    const urlRegex = /((?:https?|mailto):[^\s]+)/g;
                    encodedValue = formContent.value.replace(urlRegex, matchedUrl => isURLEncoded(matchedUrl) ? encodeURIComponent(matchedUrl) : matchedUrl);
                }
                var formContentObj = {
                    value: formContent.key === 'dateSubmitted' ? formSubmitDate : 
                        (formContent.key === "dateUpdated" ? formUpdateDate : encodedValue),
                    order: formContent.order,
                    type: formContent.type
                }
                formDetails[formContent.key] = formContentObj;
            }
        }

        var jsonString = JSON.stringify(formDetails)
        var data = {
            FormContent: jsonString 
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            } else {
                const URL = `/api/project/editform/${formlistdata.idFormSubmission}`;
                getCommonResponse.PostDetails(URL, accesstoken, data, (response) => {  
                    if(response.status == 200) {
                        setEdit(false);
                        setFormEditted(true);

                        const updatedFormContentArray = formContentArray.filter(
                            formContent => formContent.key !== ""
                        );

                        setFormContentArray(updatedFormContentArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleInputChange = (e, key, order, value) => {
        if(key != "") {
            console.log("Text length ", value.length);
            adjustTextareaHeight(e.target);
            const updatedFormContentArray = formContentArray.map(item => {
                if (item.key === key && item.order === order) {
                    return { ...item, value: value };
                }
                return item;
            });
    
            setFormContentArray(updatedFormContentArray);
        }
    }

    const handleLabelChange = (order, labelValue) => {       
        const updatedFormContentArray = formContentArray.map(item => {
            if (item.order === order) {
                return { ...item, key: labelValue };
            }
            return item;
        });

        setFormContentArray(updatedFormContentArray);
    }

    const handleAddField = () => {
        setCount(count+1);

        var newFieldObj = {
            key: '',
            value: '',
            order: count+1,
            type: "new"
        }

        setFormContentArray([...formContentArray, newFieldObj])
    }

    const DeleteNewField = (key, order) => {
        const updatedFormContentArray = formContentArray.filter(
            formContent => formContent.key !== key || formContent.order !== order
        );

        setFormContentArray(updatedFormContentArray);
    }

    useEffect(() => {
        textareaRefs.current.forEach((textarea) => adjustTextareaHeight(textarea));
    }, [formContentArray, edit]);

    const adjustTextareaHeight = (textarea) => {
        if(textarea) {
            textarea.style.height = '35px';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    function convertToPascalCase(input) {
        let tempInput = input;
        let value;
        let tempFinalValue;
        let finalValue;
        const patterns = [
            { pattern: 'PMS', replacement: 'Pms' },
            { pattern: 'URL', replacement: 'Url' },
            { pattern: 'SRP', replacement: 'Srp'}
        ]

        patterns.forEach(pattern => {
            const regex = new RegExp(pattern.pattern, 'g');
            value = tempInput.replace(regex, pattern.replacement);
            tempInput = value;
        });

        const result = value.replace(/([A-Z])/g, ' $1')
            .charAt(0).toUpperCase() + value.replace(/([A-Z])/g, ' $1').slice(1);

        tempFinalValue = result;
        patterns.forEach(pattern => {
            const regex = new RegExp(pattern.replacement, 'g');
            finalValue = tempFinalValue.replace(regex, pattern.pattern);
            tempFinalValue = finalValue
        });

        
        return finalValue;
    } 

    const linkify = (text) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(urlPattern, (url) => {
            return `<a class='blue' href="${url}" target="_blank">${url}</a>`;
        });
    };
    
    return (
        <div className="form-submission">
            <Modal show={props.showform} onHide={props.handleFormHide} className='form-submission-modal'>
                <Modal.Body className='form-submission-body'>
                    <div className='close-icon'>
                        <img src={closeicon} alt="closeicon" onClick={props.handleFormHide}></img>
                    </div>  
                    <div className='form-submission'>
                        <div className='form-header'>
                            <div className='title'>
                                { ((title.replace('pms', 'PMS')).replaceAll('-', ' ')).charAt(0).toUpperCase() +  ((title.replace('pms', 'PMS')).replaceAll('-', ' ')).slice(1)}
                            </div>
                            {page != "updates" && 
                            <>
                                {edit && 
                                <div className='add'>
                                    <img src={addIcon} alt="Add"  onClick={handleAddField}/>
                                </div>}
                                <div className='edit'>{edit ? <button className='save-btn button-enable' onClick={handleSave}>Save</button> : 
                                <img src={editIcon} alt="Edit"  onClick={handleEdit}/>}
                                </div>
                            </>}
                        </div>
                        <div className='row form-fields'>
                            {
                                formContentArray && formContentArray.map((item,i) => {
                                    return (
                                        <div className='col-12 label-content' key={i}>
                                            <div className='label-content-flex'>
                                                {item.type == "new" ? 
                                                <div>{edit ? 
                                                    <div className='new-label-container'>
                                                        <div className='new-input-field'><input type="text" placeholder='Field Name' value={item.key} onChange={(e) => handleLabelChange(item.order, e.target.value)}/></div>
                                                    </div> : 
                                                <div className='label'>{item.key}:</div>}</div> : 
                                                <div className='label'>{convertToPascalCase(item.key).replace('And', 'and')}:</div>}
                                                {(!edit) ? 
                                                <div className='content'>{parse(linkify(escapeHtml(item.value)).replaceAll('\n', '<br>'))}</div> : 
                                                    ((item.key !== 'dateSubmitted' && item.key !== 'dateUpdated') ? <textarea ref={(element) => textareaRefs.current[i] = element} value={parse(escapeHtml(item.value))} 
                                                    onChange={(e) => handleInputChange(e, item.key, item.order, e.target.value)}></textarea> : 
                                                    <div className='content'>{parse((escapeHtml(item.value)).replaceAll('\n', '<br>'))}</div>)}
                                            </div>
                                            {(item.type == "new" && edit) && <p className='delete' onClick={(e) => DeleteNewField(item.key, item.order)}>Delete</p>}
                                        </div>
                                    )
                                })
                            }                
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default FormSubmission;